import { LABELS, ROUTE_PARTS } from '@constants'
import { Business, ReceiptLong, TableView, Email, CreditCard } from '@mui/icons-material'

export const SETTINGS_NAVIGATION = [
  {
    label: LABELS.COMPANY,
    value: 'bedrijf',
    hash: '#bedrijf',
    icon: Business,
  },
  {
    label: LABELS.INVOICES,
    value: 'facturen',
    hash: `#${ROUTE_PARTS.INVOICE_LIST}`,
    icon: ReceiptLong,
  },
  {
    label: LABELS.QUOTES,
    value: 'offertes',
    hash: `#${ROUTE_PARTS.QUOTE_LIST}`,
    icon: TableView,
  },
  {
    label: LABELS.EMAIL,
    value: 'email',
    hash: '#email',
    icon: Email,
  },
  {
    label: 'Abonnement',
    value: 'subscription',
    hash: '#subscription',
    icon: CreditCard,
  },
]
